import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function ElectricalPage() {
  return (
    <div data-testid="electrical-page">
      <ServicePageTemplate
        overline="Electrical"
        title="Safe, code-compliant electrical — done right the first time."
        sub="From panel upgrades and EV chargers to full home rewires and lighting design, our licensed crews deliver clean, inspected electrical work."
        image="https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg"
        serviceTitle="Electrical"
        services={[
          "Panel Upgrades & Replacements",
          "Whole-Home Rewires",
          "EV Charger Installation",
          "Sub-Panels & Service Increases",
          "Recessed & LED Lighting",
          "Outlet, Switch & Fixture Install",
          "Ceiling Fan Installation",
          "GFCI & Code-Compliance Upgrades",
          "Generator Hookups",
          "Troubleshooting & Repairs",
        ]}
        benefits={[
          "Licensed Electricians",
          "Permits & Inspections Included",
          "Clean, Labeled Installations",
          "Up-to-Code Workmanship",
          "Reliable Scheduling",
          "Residential & Commercial",
        ]}
        faq={[
          { q: "Do I need a permit for a panel upgrade?", a: "Yes — and we handle the permit and inspection process as part of the job." },
          { q: "Can you install a Tesla/EV charger?", a: "Yes. We install Level 2 chargers for all major brands and can advise on panel capacity." },
          { q: "Do you rewire older homes?", a: "Absolutely. We safely remove knob-and-tube or aluminum wiring and replace with modern copper to code." },
        ]}
      />
    </div>
  );
}
